import React, { Component } from 'react';
import { BrowserView }  from 'react-device-detect';
import Heading from '../elements/Heading';
import globals from '../globals';

class TextImageHeading extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            leadCopy: [],
            image: ''
        };
    }

    componentDidMount() {
        globals.genericAnimation(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState(this.props.data);
        }
    }

    render() {
        const LeadCopy = this.state.leadCopy.map((paragraph, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{__html: paragraph}} />
            );
        });

        return (
            <div className="text-image-heading">
                <div className="row">
                    <BrowserView>
                        <div className="col-xs-12 col-md-3 col-md-offset-2">
                            <img src="/images/suitcase-dude.png" alt="Managed services" />
                        </div>
                    </BrowserView>
                    <div className="col-xs-12 col-md-5 heading-col">
                        <Heading title={this.state.title} leadCopy={this.state.leadCopy} />
                        {LeadCopy}
                    </div>
                </div>
            </div>
        );
    }

}

export default TextImageHeading;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/TextImageHeading.js